export const getValuePatternFromTheme = (theme, patternType = 'background-job') => {
  if (theme && theme.patterns && Array.isArray(theme.patterns) && theme.patterns.length > 0) {
    const indx = theme.patterns.findIndex((pattern) => pattern.designPattern === patternType);
    if (indx > -1) return theme.patterns[indx].value;
  }
  return '';
};

export const getSliderFromTheme = (theme) => {
  if (theme && theme.patterns && Array.isArray(theme.patterns) && theme.patterns.length > 0) {
    const indx = theme.patterns.findIndex((pattern) => pattern.designPattern === 'sliders-job');
    if (indx > -1) return theme.patterns[indx];
  }
  return '';
};

export const makeNewBannerListWithoutDuplicate = (bannerList, sliderTheme) => {
  const bannerTemp = bannerList;
  if (bannerList && sliderTheme) {
    for (let index = bannerList.length - 1; index >= 0; index--) {
      const item = bannerList[index];
      const indexSliderDuplicate = sliderTheme.items.findIndex(
        (slider) =>
          slider.duplicateImageUrl === item.desktopImage.replace('http://', '//') ||
          slider.duplicateMobileImageUrl === item.mobileImage.replace('http://', '//')
      );
      if (indexSliderDuplicate > -1) {
        bannerTemp.splice(index, 1);
      }
    }
  }
  return bannerTemp;
};
